<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    $h: 188px;
    .remote {
        height: $h;
        background-image: url("../../assets/video_bg.png")
    }

    .local {
        height: $h;
        background-image: url("../../assets/video_bg.png")
    }

    video {
        width: 100%;
        height: $h;
        background-image: url("../../assets/video_bg.png");
    }

    .btns {
        background-color: rgba(0, 0, 0, 0.5);
        height: 35px;
    }

    img {
        @include w_h(20px);
    }
</style>
<template>
    <div class="flex column">
        <div class="remote relative flex0" id="remote_video">
            <video ref="remoteVideo" autoplay :poster="require(('../../assets/video_bg.png'))"></video>
            <audio ref="remoteAudio" autoplay></audio>
            <div class="absolute l0 r0 b0 pl10 pr10 btns flex aic">
                <span class="fs15 color_fff flex1">患者视频</span>
                <i class="flex0 color_fff iconfont icon-iconzuidahua pointer"  @click='fullScreen("remote")'></i>
            </div>
        </div>
        <div class="local relative mt15 flex0" id="local_video">
            <video ref="local" muted autoplay :poster="require(('../../assets/video_bg.png'))"></video>
            <div class="absolute l0 r0 b0 pl10 pr10 btns flex aic">
                <span class="fs15 color_fff flex0">己方视频</span>
                <div class="video-btns flex1 flex aic jcc">
                    <img :src="btn.icon" :key="index" class="pointer" :class="{ml10:index>0}" @click="handler(btn.name)"
                         v-for="(btn,index) in btns" alt="">
                </div>
                <i class="flex0 color_fff iconfont icon-iconzuidahua pointer" @click='fullScreen("local")'></i>
            </div>
        </div>
<!--        <div>-->
<!--            <button @click="joinRoom">进入视频</button>-->
<!--            <button @click="leaveRoom">退出视频</button>-->
<!--        </div>-->
        <!--<message-box></message-box>
        <send-msg-box-simple></send-msg-box-simple>-->
    </div>
</template>

<script>
    import {tencentmixin} from "../../lib/video/tencentmixin";
    import {isEmpty} from "../../lib/utils";
    import MessageBox from "../common/message-box";
    import SendMsgBoxSimple from "../common/send-msg-box-simple";

    const btns = [
        /*{name: '静音', icon: require('../../assets/icon/online/jingyin.png')},
        {name: '关闭视频', icon: require('../../assets/icon/online/guanbishipin.png')},
        {name: '参会人员', icon: require('../../assets/icon/online/canhuirenyuan.png')},*/
        {name: '挂断', icon: require('../../assets/icon/online/guaduan.png')}
    ]


    export default {
        name: "online-videos",
        components: {SendMsgBoxSimple, MessageBox},
        props: {},
        mixins: [tencentmixin],
        data() {
            return {
                btns
            }
        },
        created() {

        },
        methods: {
            handler(type) {
                const map = this.handlerMap();
                const ac = [...map].find(([key]) => key === type);
                if (isEmpty(ac)) {
                    this.$message.error('未定义 ' + type + " 操作");
                } else {
                    ac[1]();
                }
            },
            handlerMap() {
                return new Map([
                    ['挂断', () => {
                        this.$confirm('是否退出房间？', '提示').then(() => {
                            this.leaveRoom();
                        })
                    }]
                ])
            },
            async enterRoom() {
                await this.getTencentSign(this.docInfo.id)
                // this.tee3enterRoom();
                console.log('userId======',this.docInfo.id)
                await this.joinRoom(this.roomId,this.docInfo.id);
            },
            // leaveRoom() {
            //     this.tee3leaveRoom();
            // },
            handlerRemoteMedia({type, stream, userId, cameraId}) {
                Log('media', {type, stream, userId, cameraId})
                if (type === 'video') {
                    Log('remoteVideo', this.$refs.remoteVideo);
                    this.$refs.remoteVideo.srcObject = stream;
                }
                if (type === 'audio') {
                    Log('remoteAudio', this.$refs.remoteAudio);
                    this.$refs.remoteAudio.srcObject = stream;
                }
            },
          fullScreen(type) {
              let ele;
              if(type=='local'){
                ele = this.$refs.local;
              }else{
                ele = this.$refs.remoteVideo;
              }
            if (ele.requestFullscreen) {
              ele.requestFullscreen();
            } else if (ele.mozRequestFullScreen) {
              ele.mozRequestFullScreen();
            } else if (ele.webkitRequestFullScreen) {
              ele.webkitRequestFullScreen();
            }
          },

        },
      beforeDestroy() {
        if( window.localPub||window.localSharePub){
          this.leaveRoom();
          window.localPub = window.localSharePub = false
        }

      }
    }
</script>
